import styled from 'styled-components';

import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { BrandM, BrandXXS, LabelXS } from '@sorare/core/src/atoms/typography';
import { S27Chip } from '@sorare/core/src/atoms/ui/Chip/S27Chip';
import { Countdown as GenericCountdown } from '@sorare/core/src/components/Countdown';
import { useIsTabletAndAbove } from '@sorare/core/src/hooks/device/useIsTabletAndAbove';

const Root = styled(Horizontal)`
  flex-shrink: 0;
`;

const Hidden = styled(LabelXS)`
  display: none;
`;

const Separator = styled(BrandXXS).attrs({ className: 'text-center' })`
  width: var(--half-unit);
  height: 100%;
  &:before {
    content: ':';
  }
`;

type Props = {
  date: Date;
};

export const Countdown = ({ date }: Props) => {
  const isTabletAndAbove = useIsTabletAndAbove();
  if (!isTabletAndAbove) {
    return (
      <Root>
        <S27Chip size="small">
          <GenericCountdown
            greyOutZeros
            date={date}
            leftPad
            Label={BrandXXS}
            Caption={Hidden}
            gap={0}
            separator={<Separator />}
          />
        </S27Chip>
      </Root>
    );
  }
  return (
    <Root>
      <GenericCountdown
        greyOutZeros
        date={date}
        Label={BrandM}
        gap={2.5}
        leftPad
      />
    </Root>
  );
};
